import { faHouseFloodWaterCircleArrowRight, faListCheck, faMaximize, faMinus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useState } from 'react'
import NormalTextArea from './NormalTextArea'
import SelectorInput from './SelectorInput'
import NormalInput from './NormalInput'
import AppContext from '../contexts/AppContext'

export default function FactorItem({ criterias, factor, frank, parentIndex, i, setCriterias, criteria }) {
    const [rank, setRank] = useState(frank)
    const { openModal } = useContext(AppContext)

    useEffect(() => {
        setRank(frank);
    }, [frank]);


    return (
        <div className={` transition-all ease-linear duration-100 cursor-pointer ${factor.minimize ? 'h-[120px] overflow-hidden' : 'h-[250px] overflow-y-scroll'}`}>
            <div className='w-full flex items-center justify-end pr-10'>
                <FontAwesomeIcon onClick={() => {
                    let c = [...criterias]
                    c[parentIndex].factors[i].minimize = !factor.minimize
                    setCriterias(c)
                }} className='h-3 w-3 mr-2 flex justify-center hover:text-white hover:bg-gray-500 border-2 border-gray-400 p-1 rounded items-center' icon={!factor.minimize ? faMinus : faMaximize} size='sm' />
                <FontAwesomeIcon onClick={() => {
                    let c = [...criterias]
                    openModal("Delete factor?", `Are you sure you want to delete "${factor.name}"`, () => () => { c[parentIndex].factors = c[parentIndex].factors.filter((f) => f != factor); setCriterias(c) })
                }} className='h-3 w-3 flex justify-center hover:text-white hover:bg-red-600/70 text-red-600/70 border-2 border-gray-400 p-1 rounded items-center' icon={faTrash} size='sm' />
            </div>
            <div className='w-full px-10 grid grid-cols-2'>
                <NormalInput icon={faHouseFloodWaterCircleArrowRight} name={'factor'} value={factor.name} onChange={(e) => {
                    const c = [...criterias]
                    const f = c[parentIndex].factors[i]
                    f.name = e.target.value
                    setCriterias(c)
                }} placeholder={'factor name'} />
                {
                    (() => {
                        let value = factor.score || (criteria.factors.length - (rank - 1)) / criteria.factors.length
                        value = (criteria.factors.length == 2 && value == 0.5) ? 0 : value
                        value = parseFloat(value.toFixed(2))
                        return (<NormalInput icon={faListCheck} type={'number'} name={'score'} value={value} disabled={true} placeholder={'factor score'} />)
                    })()
                }
                <NormalTextArea icon={faListCheck} name={'factor description'} value={factor.description} onChange={(e) => {
                    const c = [...criterias]
                    const f = c[parentIndex].factors[i]
                    f.description = e.target.value
                    setCriterias(c)
                }} rows={'1'} placeholder={'factor description'} />
                <SelectorInput label={'rank (set to change score)'} value={rank} onChange={(e) => {
                    const c = [...criterias]
                    const f = c[parentIndex].factors[i]
                    f.score = (criteria.factors.length - (e.target.value - 1)) / criteria.factors.length
                    setRank(e.target.value)
                    setCriterias(c)
                }} options={Array(criteria.factors.length).fill().map((element, parentIndex) => parentIndex + 1)} />
                <div className='col-span-2 mt-2 h-1 bg-gray-300'></div>
            </div>
        </div>
    )
}
